import { getDashboardData } from "../../apiCalls/urlFunction";
import * as actionTypes from "../actionTypes";

const STALE_TIME = 5 * 60 * 1000; // 5 minutes (increased from 10 seconds)
let pendingRequest = null; // Cache pending request

export function fetchDashboardData() {
  return async (dispatch, getState) => {
    const { Dashboard } = getState();

    // Return cached data if fresh
    if (Dashboard.data && Dashboard.lastFetchedAt &&
      Date.now() - Dashboard.lastFetchedAt < STALE_TIME) {
      return;
    }

    // Prevent duplicate simultaneous requests
    if (pendingRequest) {
      return pendingRequest;
    }

    // Don't show loading on subsequent background refreshes
    const isFirstLoad = !Dashboard.data;
    if (isFirstLoad) {
      dispatch({ type: actionTypes.DASHBOARD_LOADING });
    }

    pendingRequest = (async () => {
      try {
        const response = await getDashboardData();

        if (response?.status) {
          dispatch({
            type: actionTypes.UPDATE_ALL_DASHBOARD_DATA,
            payload: response.data,
          });
        } else {
          if (isFirstLoad) {
            dispatch({
              type: actionTypes.DASHBOARD_ERROR,
              payload: response?.error,
            });
          }
        }
      } catch (error) {
        if (isFirstLoad) {
          dispatch({
            type: actionTypes.DASHBOARD_ERROR,
            payload: error.message,
          });
        }
      } finally {
        pendingRequest = null;
      }
    })();

    return pendingRequest;
  };
}
